import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { DATE_FORMAT_DD_MMM_YYYY } from '@/helpers/common';
import { EmptyContent } from '@/components/TaxReport/EmptyContent';
import { Preloader } from '@/components/Preloader';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { CashMovementDetailModal } from '@/modals/CashMovementDetailModal';
import s from './index.module.scss';

export const List = ({ data, isLoading }) => {
  const [selected, setSelected] = useState(null);
  const { t } = useTranslation('reports');
  const { openSingleModal } = useModal();

  const onDetailClick = report => {
    setSelected(report);
    openSingleModal(MODAL_IDS.cash_movement_detail);
  };

  if (isLoading) {
    return <Preloader className={s.preloader} />;
  }

  if (!isLoading && !data?.total_count) {
    return (
      <div className={s.empty}>
        <EmptyContent />
      </div>
    );
  }

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <div className="f-tiny-accent">
          {t('cash_data.date_operation_type')}
        </div>
        <div className="f-tiny-accent">{t('cash_data.amount_balance')}</div>
      </div>
      <div className={s.list}>
        {data.list.map((item, index) => (
          <div
            className={s.item}
            key={index}
            onClick={() => onDetailClick(item)}
          >
            <div className={s.left}>
              <div className="f-body-accent">
                {prettyDate(item.created_at, DATE_FORMAT_DD_MMM_YYYY)}
              </div>
              <div className="f-small-regular">{item.operation_type}</div>
            </div>
            <div className={s.right}>
              <div className="f-body-accent">
                <span
                  style={{ color: item.amount > 0 ? '#499E1F' : '#E32144' }}
                >
                  {`${item.amount > 0 ? '+' : ''}${prettyFloatMoney(
                    item.amount,
                    {
                      decimalPlaces: 2,
                    },
                  )}`}
                </span>
              </div>
              <div className="f-small-regular">
                {prettyFloatMoney(item.balance, {
                  decimalPlaces: 2,
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
      <CashMovementDetailModal data={selected} />
    </div>
  );
};
